
const EnglishNavbarTranslations = {
    home: "Home",
    about: "About us",
    contact: "Contact",
    projects : "Projects"
}

export default EnglishNavbarTranslations;